import { createRouter, createWebHistory } from "vue-router";
import en from "@/locales/en.json";
import HomeView from "@/views/HomeView.vue";
import { useAlertStore } from "@/stores/alert";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
    meta: {
      title: `${en.title} | ${en.auth.login.title}`,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/ProfileView.vue"),
    meta: {
      title: `${en.title} | ${en.common.navigation.profile}`,
    },
  },
  {
    path: "/ingredient/list",
    name: "ingredient-list",
    component: () => import("@/views/IngredientListView.vue"),
    meta: {
      title: `${en.title} | ${en.ingredient.list}`,
    },
  },
  {
    path: "/ingredient/:id",
    name: "ingredient-details",
    component: () => import("@/views/IngredientView.vue"),
    meta: {
      title: `${en.title} | ${en.ingredient.single}`,
    },
  },
  {
    path: "/recipe/list",
    name: "recipe-list",
    component: () => import("@/views/RecipeListView.vue"),
    meta: {
      title: `${en.title} | ${en.recipe.list}`,
    },
  },
  {
    path: "/recipe/:id",
    name: "recipe-details",
    component: () => import("@/views/RecipeView.vue"),
    meta: {
      title: `${en.title} | ${en.recipe.single}`,
    },
  },
  {
    path: "/user/list",
    name: "user-list",
    component: () => import("@/views/UserListView.vue"),
    meta: {
      title: `${en.title} | ${en.user.list}`,
    },
  },
  {
    path: "/user/create",
    name: "user-create",
    component: () => import("@/views/UserCreateView.vue"),
    meta: {
      title: `${en.title} | ${en.user.create}`,
    },
  },
  {
    path: "/user/:id",
    name: "user-details",
    component: () => import("@/views/ProfileView.vue"),
    meta: {
      title: `${en.title} | ${en.common.navigation.profile}`,
    },
  },
  {
    path: "/user/:id/password/:token",
    component: () => import("@/views/CreatePasswordView.vue"),
    meta: {
      title: `${en.title} | ${en.auth.resetPassword.title}`,
    },
  },
  {
    path: "/plans",
    name: "subscription-plans",
    component: () => import("@/views/SubscriptionPlansView.vue"),
    meta: {
      title: `${en.title} | ${en.subscription.page.title}`,
    },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/PrivacyPolicyView.vue"),
    meta: {
      title: `${en.title} | Privacy Policy`,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const alertStore = useAlertStore();
  alertStore.reset();

  if (to.state?.alert) {
    alertStore[to.state.alert.type](to.state.alert.message);
  }

  document.title = to.meta.title || en.title;

  next();
});

export default router;
